import firebase from 'firebase';
import 'firebase/firestore'
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/firestore';


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAcIuu8rCRjpTYaXzUSXVi2Kf2HktAovZA",
  authDomain: "whiteboard-99711.firebaseapp.com",
  databaseURL: "https://whiteboard-99711.firebaseio.com",
  projectId: "whiteboard-99711",
  storageBucket: "whiteboard-99711.appspot.com",
  messagingSenderId: "826002079132",
  appId: "1:826002079132:web:17fabc9b2b6fc774465c59"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//npm run build;  firebase deploy --project [hosting-name]

firebase.firestore();

export default firebase;
